<template>
    <div id="cookies" v-if="!cookiesApproved">
        <div class="container-fluid py-2">
            <div class="row align-items-center">
                <div class="col flex-grow-1">
                    <div class="h5 mb-3">
                        Платформата АдминПлюс използва бисквитки
                    </div>
                    <div>
                        за повече информация виж<br>
                        <a href="#"
                           @click.prevent
                           v-b-modal.cookies-modal>
                            Политика за използване на „бисквитки“ в АдминСофт и АдминСофт Плюс
                        </a>
                    </div>
                </div>
                <div class="col flex-grow-0">
                    <button class="btn btn-warning"
                            @click="approveCookies()">
                        Затвори
                    </button>
                </div>
            </div>
        </div>
        <b-modal id="cookies-modal"
                 hide-header
                 hide-footer
                 centered
                 size="xl"
                 body-class="p-0 position-relative overflow-hidden"
                 content-class="thick-green-border">
            <div class="cookies-modal-title d-flex flex-column">
                <div class="flex-grow-1 d-flex align-items-center">
                    <div>
                        <h3 class="text-center">
                            ПОЛИТИКА ЗА
                            ИЗПОЛЗВАНЕ НА
                            „БИСКВИТКИ“
                        </h3>
                    </div>
                </div>
                <div class="flex-grow-0">
                    АдминСофт ООД<br>
                    АдминСофт Плюс ООД
                </div>
            </div>
            <div class="cookies-modal-content">
                <gdpr-cookies-text></gdpr-cookies-text>
                <p class="text-right mb-2">
                    <button class="btn btn-warning"
                            @click="$bvModal.hide('cookies-modal')">
                        Затвори
                    </button>
                </p>
            </div>
        </b-modal>
    </div>
</template>

<script>
    import GdprCookiesText from "./gdpr-component/gdpr-cookies-text";

    export default {
        name: "cookies-component",
        components: {GdprCookiesText},
        data() {
            return {
                cookiesApproved: false
            }
        },
        beforeMount() {
            const approved = window.localStorage.getItem('cookiesApproved');
            this.cookiesApproved = approved === 'approved';
        },
        methods: {
            approveCookies() {
                window.localStorage.setItem('cookiesApproved', 'approved');
                this.cookiesApproved = true;
            }
        }
    }
</script>

<style scoped>
    .cookies-modal-title {
        position: absolute;
        top: 0;
        bottom: 0;
        left: 0;
        width: 230px;
        background: #26ACAE;
        box-shadow: 0 0 10px #26ACAE;
        color: #F5F5F5;
        padding: 15px;
    }

    .cookies-modal-title h3 {
        font-size: 1.25rem;
    }

    .cookies-modal-content {
        padding: 15px 15px 15px 245px;
        max-height: calc(99vh - 3.5rem);
        overflow-y: auto;
    }

    /*size sm*/
    @media (min-width: 576px) {
    }

    /*size md*/
    @media (min-width: 768px) {
    }

    /*size lg*/
    @media (min-width: 992px) {
        .cookies-modal-title {
            width: 300px;
        }

        .cookies-modal-title h3 {
            font-size: 1.75rem;
        }

        .cookies-modal-content {
            padding: 15px 15px 15px 315px;
        }
    }

    /*size xl*/
    @media (min-width: 1200px) {
    }

</style>
